import { createSelector } from "reselect";
const selectContentsState = createSelector((state) => state.contents, contents => contents);
const selectContents = createSelector(selectContentsState, state => state.list);
const selectContent = (slug) => {
    return createSelector(selectContents, contents => (contents === null || contents === void 0 ? void 0 : contents.find((content) => (content === null || content === void 0 ? void 0 : content.slug) === slug)) || null);
};
export { selectContents, selectContent };
